// TODO: (vivian) now handle by kc, remove after release
/* eslint-disable jsx-a11y/label-has-associated-control */
import { CircularProgress } from '@ouster/webviz-react-components';

import { FormEvent, useState } from 'react';
import { RxArrowRight } from 'react-icons/rx';
import { Link } from 'react-router-dom';

import Stepper from '../../components/auth/Stepper';
import sideImg from '../../images/success-image.jpg';
import { NavBackButton } from '../../layouts/AuthLayout';
import { useStoreActions } from '../../reducers';
import styles from '../PublicPage.module.css';

const PasswordRequestConfirmation = ({ email }: { email: string }) => (
  <div className={styles['auth-content']}>
    {/* text copy on left */}
    <div
      className={`${styles['auth-copy-container']} ${styles['auth-register-error-container']}`}
    >
      <div>
        <h2 className={styles['auth-page-title']}>Check your email inbox</h2>
        <p
          className={styles['auth-page-copy']}
          style={{ textTransform: 'none' }}
        >
          An email invitation has been sent to you at{' '}
          <span style={{ color: 'var( --color-unify-active)' }}>{email}</span>.
        </p>
        <p
          className={styles['auth-page-copy']}
          style={{ textTransform: 'none' }}
        >
          Simply <strong>click the link</strong> provided there and reset your
          password.
        </p>
      </div>
    </div>

    {/* auth form on right */}
    <div className={styles['auth-form-container']}>
      <img src={sideImg} alt="" />
    </div>
  </div>
);

export default function ForgotPasswordPage() {
  const { forgotPassword } = useStoreActions((actions) => actions.user);

  const [errorMessage, setErrorMessage] = useState('');
  const [hasReset, setHasReset] = useState(false);
  const [isResetting, setIsResetting] = useState(false);
  const [email, setEmail] = useState('');

  const handleForgotPassword = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!email) return;

    setIsResetting(true);
    setErrorMessage('');

    try {
      await forgotPassword({ email });
      setHasReset(true);
    } catch (error) {
      if (error instanceof Error) {
        setErrorMessage(error.message);
      }
    } finally {
      setIsResetting(false);
    }
  };

  if (isResetting) {
    return (
      <div className={styles['loading-container']}>
        <CircularProgress isIndeterminate size="50px" thickness={10} />
      </div>
    );
  }

  const currentStep = hasReset ? 2 : 1;

  return (
    <div className={styles['auth-container']}>
      {/* back button */}
      <div className={styles['left-panel']}>
        <NavBackButton />
      </div>
      {/* stepper - showing current stage */}
      <Stepper prevStep={0} currentStep={currentStep} totalSteps={3} />
      {/* login page content */}
      <section className={styles['auth-section']}>
        <div className={styles['mobile-back-button']}>
          <NavBackButton />
        </div>

        {hasReset ? (
          <PasswordRequestConfirmation email={email} />
        ) : (
          <div className={styles['auth-content']}>
            {/* text copy on left */}
            <div className={styles['auth-copy-container']}>
              <h2 className={styles['auth-page-title']}>
                Forgot your password?
              </h2>
              <p className={styles['auth-page-copy']}>
                Enter your email to reset password
              </p>
            </div>

            {/* auth form on right */}
            <div className={styles['auth-form-container']}>
              {errorMessage !== '' && (
                <div className={styles['error-message-with-link']}>
                  {errorMessage}
                </div>
              )}
              <form
                className={styles['auth-form']}
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onSubmit={handleForgotPassword}
              >
                {/* email */}
                <p className={styles['input-header']}>
                  <label htmlFor="email">
                    Email address <sup>*</sup>
                  </label>
                </p>
                <input
                  type="email"
                  required
                  placeholder="name@company.com"
                  name="email"
                  id="email"
                  className={styles['input-field']}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button
                  className={styles['primary-button']}
                  style={{ placeContent: 'space-between' }}
                  type="submit"
                >
                  Reset Password
                  <RxArrowRight />
                </button>
              </form>

              <p className={styles['footer-link']}>
                Don’t have an account?{' '}
                <Link to="/sign_up" className={styles['link-button']}>
                  Sign up
                </Link>
              </p>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
